module.exports = __webpack_public_path__ + "static/AnshulS-211ff57732c037ee548a1dc5a6f72b14.jpg";